import { ElementNode } from 'lexical';

// Grid template lives in SCSS (not inline) so the mobile media query can collapse to one column.
const layoutClasses = {
    '2': 'gfu-editor-columns--2col',
    '3': 'gfu-editor-columns--3col',
    '1-2': 'gfu-editor-columns--1-2',
    '2-1': 'gfu-editor-columns--2-1',
};

function layoutClass(layout) {
    return layoutClasses[layout] || layoutClasses['2'];
}

function columnsClass(layout, mobileOffset) {
    const base = `gfu-editor-columns ${layoutClass(layout)}`;
    return mobileOffset > 0 ? `${base} gfu-editor-columns--mobile-offset-${mobileOffset}` : base;
}

// __mobileOffset rotates stacking order when columns collapse on mobile (0 = document order).
export class ColumnsNode extends ElementNode {
    __layout;
    __mobileOffset;

    static getType() {
        return 'columns';
    }

    static clone(node) {
        return new ColumnsNode(node.__layout, node.__mobileOffset, node.__key);
    }

    constructor(layout = '2', mobileOffset = 0, key) {
        super(key);
        this.__layout = layout;
        this.__mobileOffset = mobileOffset;
    }

    createDOM() {
        const dom = document.createElement('div');
        dom.className = columnsClass(this.__layout, this.__mobileOffset);
        return dom;
    }

    updateDOM(prevNode, dom) {
        if (prevNode.__layout !== this.__layout || prevNode.__mobileOffset !== this.__mobileOffset) {
            dom.className = columnsClass(this.__layout, this.__mobileOffset);
        }
        return false;
    }

    exportDOM() {
        const element = document.createElement('div');
        element.className = columnsClass(this.__layout, this.__mobileOffset);
        return { element };
    }

    static importJSON(serializedNode) {
        return $createColumnsNode(serializedNode.layout, serializedNode.mobileOffset);
    }

    exportJSON() {
        return {
            ...super.exportJSON(),
            type: 'columns',
            version: 1,
            layout: this.__layout,
            mobileOffset: this.__mobileOffset,
        };
    }

    isShadowRoot() {
        return true;
    }

    canBeEmpty() {
        return false;
    }

    canIndent() {
        return false;
    }
}

export function $createColumnsNode(layout = '2', mobileOffset = 0) {
    return new ColumnsNode(layout, mobileOffset);
}

export function $isColumnsNode(node) {
    return node instanceof ColumnsNode;
}
